module.exports = __webpack_public_path__ + "img/stripeCard.db7511e4.png";